<div class="dialog-header">
    <h2 mat-dialog-title>Manage Funds</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <h3>Selected Fund Valuations for the Deal</h3>
    <table mat-table [dataSource]="sellerPositionsForDeal">
        <ng-container matColumnDef="fundName" sticky>
            <th mat-header-cell *matHeaderCellDef>Fund Name</th>
            <td mat-cell *matCellDef="let element">
                @if (element.isArchived) {
                    <mat-icon class="archived-icon">inventory_2</mat-icon>
                }
                {{ element.fundName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="fundValuationDescription">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">{{ element.fundValuationDescription }}</td>
        </ng-container>

        <ng-container matColumnDef="closingDate">
            <th mat-header-cell *matHeaderCellDef>Closing Date</th>
            <td mat-cell *matCellDef="let element">{{ element.closingDate | traceableFormat }}</td>
        </ng-container>

        <ng-container matColumnDef="sellerCommitment">
            <th mat-header-cell *matHeaderCellDef>Seller Commitment</th>
            <td mat-cell *matCellDef="let element">{{ element.sellerCommitment | traceableFormat }}</td>
        </ng-container>

        <ng-container matColumnDef="remove">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button
                    mat-icon-button
                    color="primary"
                    data-test="remove-fund-valuation"
                    (click)="removeFundValuationFromDeal(element)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="dealFundsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: dealFundsColumns"></tr>
    </table>
    <br>
    <br>
    <br>

    <mat-stepper [linear]="true" #stepper (selectionChange)="onStepChange($event.selectedIndex)">
        <!-- Step 1 -->
        <mat-step [completed]="selectedFundName !== undefined">
            <ng-template matStepLabel>Select Fund</ng-template>
            <h3>Selectable Funds</h3>
            <valumize-fund-table [parentComponent]="'dealFundsManagement'" (fundClick)="selectFundAndLoadValuations($event.id, $event.name, $event.size)"></valumize-fund-table>
        </mat-step>

        <!-- Step 2 -->
        <mat-step [completed]="selectedFundValuation !== undefined">
            <ng-template matStepLabel>Select Fund Valuation</ng-template>
            <h3>Selectable Fund Valuations for "{{ this.selectedFundName }}"</h3>
            <br>
            @if (dealFundsManagementFundValuations$ | async; as fundValuations) {
                @if (filterFundValuations(fundValuations.data); as filteredFundValuations) {
                    @if (filteredFundValuations.length !== 0) {
                        <table mat-table [dataSource]="filteredFundValuations">
                            <ng-container matColumnDef="fundName" sticky>
                                <th mat-header-cell *matHeaderCellDef>Fund</th>
                                <td mat-cell *matCellDef="let element">{{ selectedFundName }}</td>
                            </ng-container>
                            <ng-container matColumnDef="reportDate">
                                <th mat-header-cell *matHeaderCellDef>Report Date</th>
                                <td mat-cell *matCellDef="let element">{{ element.reportDate | traceableFormat }}</td>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef>Description</th>
                                <td mat-cell *matCellDef="let element">{{ element.description | traceableFormat }}</td>
                            </ng-container>
                            <ng-container matColumnDef="closingDate">
                                <th mat-header-cell *matHeaderCellDef>Closing Date</th>
                                <td mat-cell *matCellDef="let element">{{ element.closingDate | traceableFormat }}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fundValuationColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: fundValuationColumns"
                                (click)="selectFundValuation(row); stepper.next()">
                            </tr>
                        </table>
                    } @else {
                        <mat-card-content class="detail-card-content" style="color: grey">
                            No fund valuations with this deal's closing date or later are available. Please create one first.
                        </mat-card-content>
                    }
                }
            }
            <div>
                <button mat-stroked-button color="primary" class="button-margin" (click)="goBackToList(); stepper.previous()">Back</button>
                @if (selectedFundValuation === undefined) {
                    <button
                        mat-stroked-button
                        mat-dialog-close
                        data-test="save-button-bottom"
                        (click)="navigateToFund()">
                        Go to Fund - {{ selectedFundName }}
                    </button>
                }
            </div>
        </mat-step>

        <!-- Step 3 -->
        <mat-step [stepControl]="sellerPositionForm">
            <ng-template matStepLabel>Enter Seller Commitment</ng-template>
            <form [formGroup]="sellerPositionForm">
                <mat-form-field appearance="fill">
                    <mat-label>Seller Commitment</mat-label>
                    <input matInput formControlName="sellerCommitment" id="sellerCommitment">
                    @if (sellerPositionForm.controls.sellerCommitment.hasError('required')) {
                        <mat-error>Seller commitment is required.</mat-error>
                    }
                    @if (sellerPositionForm.controls.sellerCommitment.hasError('sellerCommitmentTooHigh')) {
                        <mat-error>Cannot be larger than the fund size ({{ selectedFundSize | traceableFormat }}).</mat-error>
                    }
                </mat-form-field>
            </form>
            <div style="margin-top: 24px">
                <button mat-stroked-button color="primary" class="button-margin" (click)="goBackToValuations()">Back</button>
                <button mat-stroked-button color="primary" class="button-margin" [disabled]="sellerPositionForm.invalid"
                        (click)="addFundValuationToDeal(); stepper.next()">Add
                </button>
            </div>
        </mat-step>

        <!-- Step 4 -->
        <mat-step>
            <ng-template matStepLabel>Done</ng-template>
            <p>Successfully added Fund Valuation!</p>
            <button mat-stroked-button color="primary" class="button-margin" (click)="resetStepper()">Add another fund</button>
        </mat-step>
    </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-stroked-button
        color="primary"
        mat-dialog-close
        data-test="save-button-bottom"
        (click)="save()"
        [disabled]="sellerPositionForm.invalid || stepper.selectedIndex === 2">
        Save
    </button>
</mat-dialog-actions>

